"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.prompt.title': 'Toggle Advanced Prompts',
    'shortcuts.prompt.description': 'Enable or disable advanced prompt structure and slot system',
};
